import React from 'react'
import { ApplicationPage } from '.'
import { ApplicantType, ApplicationType } from 'shared'

export default function CorporateLoanPage(){
    return <ApplicationPage type={ApplicationType.Loan} applicantType={ApplicantType.Corporate} />
}